import { ConnectEmailMethod, MasterTranslation } from '@/constants';
import { useGlobalState } from '@/hooks';
import { ConnectGoogleButton } from '@/modules/pmt/components/ConnectGoogleButton';
import { TrackingWidget } from '@/modules/pmt/components/TrackingWidget';
import { useMyParcelsContext } from '@/modules/pmt/context';
import { gtmClickEsyncCta, gtmConnectEmailSuccess, gtmViewEsyncCta } from '@/utils';
import { type FC, type JSX, useEffect } from 'react';
import { ESLoggedInDivider, ESLoggedInWrapper, ESMainText } from '../../DefaultTrackingContainer.styles';

interface ILoggedInESBannerProps {
  squareAd?: JSX.Element;
  searchShipments: (trackingIds: string[]) => void;
}
export const LoggedInESBanner: FC<ILoggedInESBannerProps> = ({ squareAd, searchShipments }) => {
  const { t } = useGlobalState();
  const { notificationTranslation } = useMyParcelsContext();

  useEffect(() => {
    gtmViewEsyncCta({ variant: notificationTranslation.identifier });
  }, []);

  return (
    <>
      <ESLoggedInWrapper>
        <img
          src='/images/es-banner-logged-in-no-parcels.svg'
          alt='logged-in-no-parcels'
          width={320}
          height={160}
          style={{
            objectFit: 'contain',
          }}
        />
        <ESMainText>{notificationTranslation.loggedInEsMainText}</ESMainText>
        <ConnectGoogleButton
          buttonText={notificationTranslation.loggedInEsNoParcelsButtonText}
          handleClick={() => gtmClickEsyncCta({ variant: notificationTranslation.identifier })}
          onSuccess={() => gtmConnectEmailSuccess(ConnectEmailMethod.EsyncCta)}
        />
      </ESLoggedInWrapper>
      <ESLoggedInDivider>
        <span>{t(MasterTranslation.Or)}</span>
      </ESLoggedInDivider>
      {/* TW input + Add parcels button */}
      <TrackingWidget handleSubmit={searchShipments} isDisabled />

      {squareAd}
    </>
  );
};
